import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "career" }
const _hoisted_2 = { class: "career-hero" }
const _hoisted_3 = { class: "career-hero-content" }
const _hoisted_4 = { class: "career-hero-points" }
const _hoisted_5 = { class: "career-benefits" }
const _hoisted_6 = { class: "benefit-card" }
const _hoisted_7 = { class: "benefit-card" }
const _hoisted_8 = { class: "benefit-card" }
const _hoisted_9 = { class: "jobs-section" }
const _hoisted_10 = { class: "jobs-grid" }
const _hoisted_11 = { class: "job-card" }
const _hoisted_12 = { class: "job-icon" }
const _hoisted_13 = { class: "job-card" }
const _hoisted_14 = { class: "job-icon" }
const _hoisted_15 = { class: "popup-box" }
const _hoisted_16 = { class: "career-form" }
const _hoisted_17 = {
  type: "submit",
  class: "submit-btn"
}

import {ref} from "vue";
import {BriefcaseBusiness, Clock3, Euro, FileText, GraduationCap, Send, ShieldCheck, Users, Wrench} from "lucide-vue-next";

import "@/assets/styles/career.css";



export default /*@__PURE__*/_defineComponent({
  __name: 'CareerView',
  setup(__props) {

const showForm = ref(false);

const selectedJob = ref("Dachdecker");

const openForm = (job: string) => {
  selectedJob.value = job;
  showForm.value = true;
};

const closeForm = () => {
  showForm.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "section-badge" }, " Karriere im Dachdeckerhandwerk ", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("h1", null, " Arbeiten, wo man abends sieht, was man geschafft hat. ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, " Bei uns geht es um saubere Dächer, ein verlässliches Team und Projekte, auf die du stolz sein kannst: Sanierungen, Flachdächer, Sturmschäden und moderne Dachsysteme in der Region. ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createVNode(_unref(ShieldCheck)),
            _cache[2] || (_cache[2] = _createTextVNode(" Festanstellung möglich", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Wrench)),
            _cache[3] || (_cache[3] = _createTextVNode(" Moderne Ausstattung", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Clock3)),
            _cache[4] || (_cache[4] = _createTextVNode(" Klare Abläufe", -1))
          ])
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "career-hero-image" }, [
        _createElementVNode("img", {
          src: "/images/career/ausbildung-v2.png",
          alt: "Auszubildende und erfahrener Dachdecker arbeiten gemeinsam"
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Users)),
        _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Starkes Team", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", null, "Kollegiales Arbeiten, kurze Wege und Menschen, die aufeinander achten.", -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(Euro)),
        _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Faire Bezahlung", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("p", null, "Leistung soll sich lohnen: zuverlässig, transparent und mit Perspektive.", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(GraduationCap)),
        _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Weiterentwicklung", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Du lernst dazu, übernimmst Verantwortung und wächst im Handwerk.", -1))
      ])
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "career-story" }, [
      _createElementVNode("div", null, [
        _createElementVNode("span", { class: "section-badge" }, "Was dich erwartet"),
        _createElementVNode("h2", null, "Kein anonymer Großbetrieb. Kein Chaos auf Zuruf.")
      ]),
      _createElementVNode("p", null, " Wir arbeiten strukturiert, halten Baustellen sauber und sprechen offen. Du bekommst klare Aufgaben, vernünftiges Werkzeug und ein Team, das Qualität ernst nimmt. Genau so wollen Kunden bedient werden und genau so macht Handwerk auch langfristig Spaß. ")
    ], -1)),
    _createElementVNode("div", _hoisted_9, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "jobs-header" }, [
        _createElementVNode("h2", null, "Offene Stellen"),
        _createElementVNode("p", null, "Bewirb dich unkompliziert. Ein kurzer erster Kontakt reicht.")
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(BriefcaseBusiness))
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Dachdecker (m/w/d)", -1)),
          _cache[16] || (_cache[16] = _createElementVNode("p", null, " Verstärke unser Team im Bereich Steildach, Flachdach, Sanierung und Reparatur. ", -1)),
          _cache[17] || (_cache[17] = _createElementVNode("ul", null, [
            _createElementVNode("li", null, "Erfahrung im Dachdeckerhandwerk"),
            _createElementVNode("li", null, "Saubere, zuverlässige Arbeitsweise"),
            _createElementVNode("li", null, "Führerschein von Vorteil")
          ], -1)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openForm('Dachdecker'))),
            class: "apply-btn"
          }, " Jetzt bewerben ")
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(FileText))
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Ausbildung Dachdecker", -1)),
          _cache[19] || (_cache[19] = _createElementVNode("p", null, " Starte deine Ausbildung im Handwerk mit Zukunft und Perspektive. ", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("ul", null, [
            _createElementVNode("li", null, "Interesse an praktischer Arbeit"),
            _createElementVNode("li", null, "Teamgeist und Lernbereitschaft"),
            _createElementVNode("li", null, "Begleitung durch erfahrene Kollegen")
          ], -1)),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openForm('Ausbildung'))),
            class: "apply-btn"
          }, " Ausbildung starten ")
        ])
      ])
    ]),
    (showForm.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "popup-overlay",
          onClick: _withModifiers(closeForm, ["self"])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeForm
            }, " × "),
            _createElementVNode("h2", null, " Bewerbung als " + _toDisplayString(selectedJob.value), 1),
            _createElementVNode("form", _hoisted_16, [
              _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"form-grid\"><div class=\"form-group\"><label>Vorname</label><input type=\"text\" placeholder=\"Max\"></div><div class=\"form-group\"><label>Nachname</label><input type=\"text\" placeholder=\"Mustermann\"></div></div><div class=\"form-group\"><label>E-Mail</label><input type=\"email\" placeholder=\"mail@example.de\"></div><div class=\"form-group\"><label>Telefon</label><input type=\"text\" placeholder=\"+49 ...\"></div><div class=\"form-group\"><label>Nachricht</label><textarea rows=\"5\" placeholder=\"Erzähl uns etwas über dich...\"></textarea></div><div class=\"upload-grid\"><label class=\"upload-box\"> Lebenslauf hochladen <input type=\"file\" hidden></label><label class=\"upload-box\"> Anschreiben hochladen <input type=\"file\" hidden></label></div>", 5)),
              _createElementVNode("button", _hoisted_17, [
                _createVNode(_unref(Send)),
                _cache[22] || (_cache[22] = _createTextVNode(" Bewerbung senden ", -1))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})